export const COOKIES = Object.freeze({
  ACTIVE_USER_NAME: 'ActivUserName',
  ACTIVE_USER_CONTACTS_COUNT: 'ActivUserContactsCount',
  CURRENT_LANG: 'currentLang',
  IS_FIRST_LOGIN: 'IsFirstLogin',
  DASHBOARD: 'dashboard',
  MULTI_ACCOUNTS: 'multiAccounts',
  TARTEAUCITRON: 'PartnerPortal_tarteaucitron',
});
